// Calculators that other sites may embed (growth list #4, Oct 20 2026; deposit and invoice
// due date added Oct 22 2026 by the authority lab). Each has a
// chrome-less /embed/tools/<slug>/ page (noindex, canonical to the tool page, kept out of
// seo-routes and the sitemap) and an "Embed this calculator" panel on the tool page.
// height: the snippet's iframe height, measured so the whole calculator shows in a 700px
// blog column (Oct 20 2026, plus ~30px). Wider frames leave space below; phone-width frames
// scroll inside. Re-measure after changing a calculator's layout.
export const toolEmbeds = [
  { slug: 'hourly-rate-calculator', title: 'Hourly rate calculator', height: 1310 },
  { slug: 'late-fee-calculator', title: 'Late fee calculator', height: 950 },
  { slug: 'retainer-calculator', title: 'Retainer calculator', height: 1370 },
  { slug: 'consulting-rate-calculator', title: 'Consulting rate calculator', height: 1250 },
  { slug: 'profit-margin-calculator', title: 'Profit margin calculator', height: 1190 },
  { slug: 'deposit-calculator', title: 'Deposit calculator', height: 940 },
  { slug: 'invoice-due-date-calculator', title: 'Invoice due date calculator', height: 950 },
];

export const toolEmbedPath = (slug) => `/embed/tools/${slug}/`;

export const isEmbedPath = (path) => /^\/embed(\/|$)/.test(path || '');

export const toolEmbedFor = (toolPath) =>
  toolEmbeds.find((tool) => `/tools/${tool.slug}` === String(toolPath || '').replace(/\/$/, '')) || null;

const escapeAttr = (value) =>
  String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Plain iframe plus a visible credit link to the tool page. No script, no hidden links.
export function toolEmbedSnippet(tool, origin = 'https://workspace369.com') {
  const toolUrl = `${origin}/tools/${tool.slug}/`;
  return `<iframe src="${origin}${toolEmbedPath(tool.slug)}" title="${escapeAttr(tool.title)}" width="100%" height="${tool.height}" style="border:0;max-width:100%" loading="lazy"></iframe>\n`
    + `<p style="margin:6px 0 0;font-size:14px"><a href="${toolUrl}">Calculator by Workspace369</a></p>`;
}
